import { useEffect, useRef } from 'react';

import { triggerAddIfRequested } from './utils';

const useTriggerAddIfRequested = (setEditedSection, onAdd) => {
  const hasFiredRef = useRef(false);

  useEffect(() => {
    triggerAddIfRequested({ setEditedSection, hasFiredRef, onAdd });
  }, [setEditedSection, onAdd]);
};

export default useTriggerAddIfRequested;
